const generator = require('./retail-fullcont-multitable-generator')

export function start(detail) {
      obj[detail.act].start(detail)
}

const obj = {
      add: { start: (detail) => { add(detail) } },
}

function add(detail) {
      retailMT.forEach((mt) => {
            if (mt.tableName === detail.tableName) {
                  mt.add(detail.tab !== undefined)
            }
      })
}

export const retailMT = [
      {
            tableName: 'sale_vs_item',
            value: '',
            id: 'retail_form_sale_vs_item',
            html: '',
            data: [],
            dataCopy: [],
            oneRequired: true,
            fields: [
                  { name: 'purchase_vs_itemId', type: 'autocomplete', html: '', required: true },
                  { name: 'selling_type', type: 'textfield', html: '', required: false },
                  { name: 'qty', type: 'textfield', html: '', required: true },
                  { name: 'cost', type: 'textfield', html: '', required: false },
                  { name: 'cogs_row_amount', type: 'textfield', html: '', required: false },
                  { name: 'price', type: 'textfield', html: '', required: true },
                  { name: 'total', type: 'textfield', html: '', required: true },
            ],

            generator: function (line) {
                  return generator.sale_vs_item(line.id, line.purchase_vs_itemId)
            },

            add: function (tab = false) {
                  const newLine = generator.sale_vs_item('')
                  this.html.insertAdjacentHTML('beforeend', newLine)

                  const allLines = this.html.querySelectorAll('.purchase_vs_itemId')
                  const lastLine = allLines[allLines.length - 1]
                  const targetInput = lastLine.querySelector('input')

                  targetInput.focus()
                  if (!tab) { targetInput.click() }
            },
      },
]
